import React from 'react';
import { User, Shield, Heart, Users, TrendingUp, Home } from 'lucide-react';

const values = [
  {
    icon: User,
    title: 'Person-Centred Care',
    description: 'Every resident is treated as an individual, with care tailored to their personal needs, preferences and routines.',
  },
  {
    icon: Shield,
    title: 'Safety & Quality First',
    description: 'We prioritise safety through strong clinical governance, robust processes and continuous monitoring.',
  },
  {
    icon: Heart,
    title: 'Dignity & Respect',
    description: 'We support independence and treat every resident with compassion, kindness and respect.',
  },
  {
    icon: Users,
    title: 'Family Partnership',
    description: 'We work closely with families, ensuring open communication and involvement in care decisions.',
  },
  {
    icon: TrendingUp,
    title: 'Continuous Improvement',
    description: 'We invest in training, development and innovation to improve the quality of care we provide.',
  },
  {
    icon: Home,
    title: 'A True Home Environment',
    description: 'We create a warm, welcoming atmosphere where residents feel comfortable, secure and valued.',
  },
];

const ValuesSection = () => {
  return (
    <section
      id="values"
      className="py-20 md:py-32 bg-white"
      data-testid="values-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#1e3a5f]/10 rounded-full text-[#1e3a5f] text-sm font-medium mb-6">
            Our Values
          </div>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e3a5f] mb-6"
           
          >
            Putting People at the Heart of Care
          </h2>
          <p className="text-slate-600 text-lg">
            At RSJB Nursing Homes, our approach is guided by strong values that ensure every resident receives exceptional care.
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => {
            const IconComponent = value.icon;
            return (
              <div
                key={value.title}
                className="bg-slate-50 rounded-2xl p-8 hover:bg-white hover:shadow-xl transition-all duration-300 border border-transparent hover:border-[#c9a227]/30 group"
                data-testid={`value-card-${index}`}
              >
                <div className="w-14 h-14 rounded-xl bg-[#1e3a5f]/10 flex items-center justify-center mb-6 group-hover:bg-[#c9a227]/20 transition-colors duration-300">
                  <IconComponent className="w-7 h-7 text-[#1e3a5f] group-hover:text-[#c9a227] transition-colors duration-300" />
                </div>
                <h3
                  className="text-xl font-bold text-[#1e3a5f] mb-3"
                 
                >
                  {value.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
